// extracted by mini-css-extract-plugin
export default {"topbtn":"scroll_topbtn__bURGr","icon":"scroll_icon__BIrLq","gototop":"scroll_gototop__V0+ZX"};